import { BillingAddressType } from 'features/Billing'
import { DocumentInterface } from 'features/Documents'
import { HaulageDetails, IContact } from 'features/ShipmentDetails'

import { User } from './User'

export interface PaymentTerm {
  trigger: 'booking' | 'delivery' | 'departure'
  dueDays: number
}

enum FinanceDocument {
  freightHubAdvanceInvoice = 'freightHubAdvanceInvoice',
  freightHubAdditionalCharge = 'freightHubAdditionalCharge',
  freightHubInvoice = 'freightHubInvoice',
  freightHubCustomsInvoice = 'freightHubCustomsInvoice',
}

type InvoicePackageTerm = {
  packageDocuments: FinanceDocument[]
}

type AdvanceCommission = {
  // Charge percent, 1 by default
  percentage: number
  // How many days customer has to pay to get advance commission deducted, 0 if no deduction applies
  deductionDueDays: number
}

type CustomsPaymentTerm = {
  // Amount of days to pay after issuance of the invoice, 0 by default
  dueDays: number
  advanceCommission: AdvanceCommission
}

type LogexTeam = 'germany' | 'denmark'

export interface IAssignee {
  _id: string
  name: string
  email: string
  phone?: string
  thumbnailUrl: string
}

interface IAssignees {
  ops: IAssignee
  sales: IAssignee
}

interface IPreferredTransportModes {
  sea?: string | number
  air?: string | number
  rail?: string | number
  seaAir?: string | number
}

enum CustomerDeactivationReason {
  FBA_SERVICE_STOP = 'FBA_SERVICE_STOP',
}

export enum CustomerFeature {
  COST_BREAKDOWN = 'COST_BREAKDOWN',
  SUPPLIER_BOOKING = 'SUPPLIER_BOOKING',
  NPS_EMAIL = 'NPS_EMAIL',
  PURCHASE_ORDER_MANAGEMENT = 'PURCHASE_ORDER_MANAGEMENT',
  DANGEROUS_GOODS_AUTO_QUOTE = 'DANGEROUS_GOODS_AUTO_QUOTE',
  NEW_SHIP_UI = 'NEW_SHIP_UI',
  OFFSET_SERVICE = 'OFFSET_SERVICE',
}

abstract class CustomsAccountInterface {
  // @ts-expect-error TS(2564) FIXME: Property 'accountNumber' has no initializer and is... Remove this comment to see the full error message
  accountNumber: string
  // @ts-expect-error TS(2564) FIXME: Property 'binNumber' has no initializer and is not... Remove this comment to see the full error message
  binNumber: string
}

class CustomsAccount implements CustomsAccountInterface {
  accountNumber = ''
  binNumber = ''
}

export type Customer = {
  _id: string
  eoriNumber: string
  name: string
  createdAt: Date
  documents: DocumentInterface[]
  billingAddress: BillingAddressType
  customsDefermentAccount?: CustomsAccount
  vatAccount?: CustomsAccount
  invoicingAvailable: boolean
  showCarrierLogos: boolean
  users: User[]
  users_id: string[]
  importPaymentTerm: PaymentTerm
  exportPaymentTerm: PaymentTerm
  invoicePackageTerm: InvoicePackageTerm
  customsPaymentTerm: CustomsPaymentTerm
  shipperContacts: IContact[]
  consigneeContacts: IContact[]
  isUserlaneEnabled: boolean
  userlaneCompletedAt: Date
  pickupDetails: HaulageDetails[]
  deliveryDetails: HaulageDetails[]
  isDemo: boolean
  // The customer segment from salesforce
  segment: string | null
  assignees?: IAssignees
  preferredTransportModes?: IPreferredTransportModes
  addLandedCostTax: boolean
  enabledFeatures: CustomerFeature[]
  activeRegularStatus: string | null
  // determines if the customer is digital or old-economy,
  // especially relevant for SMBs
  digitalLiteracy?: string

  // Date at which this customer has been activated
  activatedAt?: Date
  deactivatedAt?: Date
  deactivationReason?: CustomerDeactivationReason
  hasDemoData: boolean
  modifiedAt: Date
  sfSyncedAt: Date
  ownerId: string
  documents_id: string[]
  signupId?: string
  hideMainFAKRates?: boolean
  hideCarriageFAKRates?: boolean
  hideDepotFAKRates?: boolean
  hideCustomsFclFAKRates?: boolean
  hideCustomsLclFAKRates?: boolean
  hideMaerskSpotMainRates?: boolean
  logexTeam: LogexTeam
  sendInvoice?: boolean
}

export function customerHasFeature(customer: Customer, feature: CustomerFeature): boolean {
  return !!customer.enabledFeatures && customer.enabledFeatures.indexOf(feature) > -1
}
